import registryJson from "../../data/schema/search-index-registry.json";

interface SearchIndexRegistry {
  version: number;
  description: string;
  principle: string;
  groups: Array<{ reason: string; paths: string[] }>;
}

const registry = registryJson as SearchIndexRegistry;

/**
 * Detail paths the catalog is allowed to search. Everything else under
 * `details` still renders in the overlay but stays out of the index, so a
 * query matches a record's own identity rather than its prose, its links, or
 * the models it points at.
 *
 * `scripts/lib/search-index.mjs` reads the same registry when it precomputes
 * `record.searchText`, which keeps the build-time and runtime indexes aligned.
 */
export const INDEXED_DETAIL_PATHS: ReadonlySet<string> = new Set(
  registry.groups.flatMap((group) => group.paths)
);

export function isIndexedDetailPath(path: string): boolean {
  return INDEXED_DETAIL_PATHS.has(path);
}
